<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Form Instructions
        </p>
        <button
          id="moda-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p>Please, click the download button below to find specific instructions on how to complete each form.</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a
          href="../../pdfs/form-instructions.pdf"
          target="_blank"
          class="button is-small is-secondary"
          download
        >
          <span>Download Instructions</span>
          <span class="icon">
            <i class="is-small fad fa-file-download" />
          </span>
        </a>
      </footer>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      content: '',
    };
  },
  methods: {
    closeModal() {
      if (!this.submitting) {
        this.$emit('close');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .close-button {
    font-size: 25px;
    line-height: 0;
  }
</style>
